import { authenticatedFetch, parseAuthenticatedJson } from '../services/authenticatedFetch';
import { API_URL } from '../config';

export { API_URL };

export const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getCurrentCenterId = () => localStorage.getItem('currentCenterId');

export const apiRequest = async (endpoint: string, options: RequestInit = {}): Promise<any> => {
  const url = endpoint.startsWith('http') ? endpoint : `${API_URL}${endpoint}`;
  const response = await authenticatedFetch(url, options);
  return parseAuthenticatedJson(response);
};

export const addCenterIdToParams = (params: URLSearchParams): URLSearchParams => {
  const centerId = getCurrentCenterId();
  if (centerId) {
    params.append('centerId', centerId);
  }
  return params;
};

export const createUrlWithCenterId = (
  baseEndpoint: string,
  params?: Record<string, any>,
  centerIdOverride?: number | string | null,
): string => {
  const centerId =
    centerIdOverride !== undefined ? centerIdOverride?.toString() || null : getCurrentCenterId();

  const urlParams = new URLSearchParams();

  if (params) {
    Object.keys(params).forEach((key) => {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        urlParams.append(key, params[key]);
      }
    });
  }

  if (centerId) {
    urlParams.append('centerId', centerId);
  }

  const queryString = urlParams.toString();
  return queryString ? `${baseEndpoint}?${queryString}` : baseEndpoint;
};
